var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4h14m-10 11h6a2 2 0 002-2V3a2 2 0 00-2-2h-6a2 2 0 00-2 2v10a2 2 0 002 2z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--remove-85a4efbc9e084b67856e70ca38c99b06.svg";
export { SvgIconUiRemove as Component };